__turbopack_context__.v({
  "dropdown": "Ej2gTW_dropdown",
  "item": "Ej2gTW_item",
  "itemLabel": "Ej2gTW_itemLabel",
  "selected": "Ej2gTW_selected",
});
